import {DropzoneComponent} from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import React, {Component} from 'react';
import {Button, Header,Icon, Modal} from 'semantic-ui-react';
import {uploadSOCImage} from "../../data/report_api";
import ReportContainer from "../../containers/report_container";
import Loader from "../universal/loader";
import ScheduleOfConditionsGenerator from './soc_generator/schedule_of_conditions_generator';

const uuidv1 = require('uuid/v1');

class ScheduleOfCondition extends Component {

    constructor(props) {
        super(props);
        this.state = {
            attachments: [],
            maxNumberOfFilesExceeded: false,
            saved: false,
            uploading:false,
            preLoaded:false
        };
    }

    handleSubmit = () => {
        this.setState({uploading:true});
        const formData = new FormData();
        if(this.state.attachments.length > 0 && !this.state.preLoaded){
            formData.append("report_id", this.props.reportId);
            formData.append("images[id]", uuidv1());
            formData.append("images[file]", this.state.attachments[0]);
            uploadSOCImage(formData).then((response) => {
                if(response.success){
                    this.setState({saved: true,uploading:false,attachments:[]});
                }
                else {
                    this.setState({saved: false,uploading:false,attachments:[]});
                }
                setTimeout(() => {
                    this.setState({saved: false});
                }, 20000);
            });
        }
        else {
            this.setState({saved: false,uploading:false,attachments:[]});
        }
    };

    preloadImages = (dropzone) => {
        const socImage = this.props.reportDetails.soc;
        if (socImage && socImage.images) {
            const name = socImage.images.id;
            const file = {url: socImage.images['image_path'], name: name, size: 1000000, id: name};
            const imageUrl =socImage.images['image_path'];

            file['serverId'] = name;
            file['accepted'] = true;
            file['status'] = 'success';
            file['upload'] = {
                progress: 100,
                total: 100000,
                bytesSent: 100000
            };
            dropzone.files.push(file);
            this.state.attachments.push(file);
            this.setState({preLoaded:true});
            dropzone.emit("addedfile", file);
            dropzone.emit("thumbnail", file, imageUrl);
            dropzone.emit("complete", file);
        }
    };

    useImage = (file) => {
            fetch(file).then(res => {
              res.arrayBuffer().then(buf => {
                  const filer = new File([buf], 'soc_image.png', { type: 'image/png' })
                  this.dropZone.emit("addedfile", filer)
                  this.dropZone.emit("thumbnail", filer,file);
              })
            })        
        this.setState({generating:false})
    }

    render() {

        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};
        let djsConfig = {autoProcessQueue: false, addRemoveLinks: true, maxFiles: 1,acceptedFiles:"image/*"};
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                this.dropZone = dropzone
                dropZone.autoDiscover = false;
                this.preloadImages(dropzone);
            },
            addedfile: (file) => {
                this.state.attachments.push(file);
                this.setState({fileAdded:true,preLoaded:false});
            },
            removedfile: (file) => {
                this.setState({attachments:[],saved:false});
            },
            maxfilesexceeded: (file) => {
                dropZone.removeFile(file);
                this.setState({maxNumberOfFilesExceeded: true});
                setTimeout(() => {
                    this.setState({maxNumberOfFilesExceeded: false})
                }, 10000)
            }
        };
        return (<div>
            {this.state.uploading && <Loader save={true}/>}
            <Header textAlign="left"> Schedule of Condition {this.state.saved &&
            <span className="info-success">Saved!</span>} <Button primary compact content="Save" disabled={this.state.uploading} loading={this.state.uploading}
                                                                  className="pull-right icon-button"
                    onClick={this.handleSubmit} />{this.state.attachments.length > 0 && !this.state.preLoaded && <span className="pull-right"><Icon name="warning sign" color="orange" size="large" /></span>}{!this.state.attachments.length > 0 && !this.state.saved && <span className="pull-right"><Button onClick={()=>{this.setState({generating:true})} }compact content="Generate"/> </span> }</Header>
            {this.state.maxNumberOfFilesExceeded &&
            <p><span className="error-message">Max number of allowed files is 1</span></p>}
            <DropzoneComponent key={this.props.reportId} config={componentConfig}
                               eventHandlers={eventHandlers}
                               djsConfig={djsConfig}/>
        
            <Modal size={"fullscreen"} open={this.state.generating} closeOnDimmerClick={false}>
            <Modal.Content style={{ padding: "0px" }} >
                        <div className="modal-close-button">
                        <Button basic icon negative onClick={(e) => {
                            this.setState({ generating: false })
                            }}><Icon name="close"/></Button>
                    </div>
                    <Modal.Description>
                        <ScheduleOfConditionsGenerator useImage={ this.useImage}reportDetails={this.props.reportDetails} ></ScheduleOfConditionsGenerator>
                    </Modal.Description>
                    </Modal.Content>
                    </Modal>
        </div>);
    }
}

export default ReportContainer(ScheduleOfCondition);


// WEBPACK FOOTER //
// ./src/views/report/schedule_of_condition.js